
// 临时测试用
let booleanTemp = true;
var validateEng = (rule, value, callback) => {
    let reg = /^[\da-z]+$/i;
    if (reg.test(value)) {
        callback();
    } else {
        callback(new Error("请输入英文或者字母、数字"));
    }
};

var validateEngPass = (rule, value, callback) => {
    let zmReg = /[A-Za-z]/; // 大小写字母
    let numReg = /[0-9]/; // 数字
    let zfReg = /[^A-Za-z0-9\s]/; // 特殊字符不包含空格
    let complex = 0;
    if (zmReg.test(value)) {
      ++complex;
    }
    if (numReg.test(value)) {
      ++complex;
    }
    if (zfReg.test(value)) {
      ++complex;
    }
    if (complex < 2) {
      // 密码需包含字母，符号或者数字中至少两项
      callback(new Error("密码需包含字母，符号或者数字中至少两项"));
    } else {
      callback();
    }
};

// 企业
export function RnterpriseFrom() {
    return {
        accountType: [{ required: true, message: "请选择账号类型", trigger: "change" }],
        memberType: [{ required: true, message: "请选择会员类型", trigger: "change" }],
        username: [
            { required: true, message: "请输入账号", trigger: "blur" },
            { validator: validateEng, trigger: "blur" },
        ],
        password: [
            { required: true, message: "请输入密码", trigger: "blur" },
            { min: 6, message: "密码需要在长度在6位以上", trigger: "blur" },
            { validator: validateEngPass, trigger: "blur" },
        ],

        // 单位名称
        companyName: [
            { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        // 统一社会信用代码
        creditCode: [{ required: true, message: "请输入统一社会信用代码", trigger: "blur" }],
        // 单位性质
        unitProperties: [
            { required: true, message: "请选择单位性质", trigger: "change" },
        ],
        // 成立时间
        establishmentDate: [
            { required: true, message: "请输入成立时间", trigger: "blur" },
        ],
        // 注册资金
        registeredCapital: [
            { required: true, message: "请输入注册资金", trigger: "blur" },
            { type: "number", message: "必须为数字值", trigger: "blur" },
        ],
        // 单位电话
        workTelephone: [{ required: true, message: "请输入单位电话", trigger: "blur" }],
        // 邮编
        postalCode: [{ required: true, message: "请输入邮编", trigger: "blur" }],
        // 近年三年年度营业额
        yearTurnover: [
            {
                validator: (rule, value, callback) => {
                    if (
                        this.yearTurnover[0] &&
                        this.yearTurnover[1] &&
                        this.yearTurnover[2]
                    ) {
                        callback();
                        return;
                    }
                    callback(new Error("请输入近年三年年度营业额"));
                },
                trigger: "blur",
            },
        ],
        yearTurnover1: [
            {
                validator: (rule, value, callback) => {
                    if (this.yearTurnover[0]) { callback(); return; }
                    callback(new Error("请输入近年三年年度营业额"));
                },
                trigger: "blur",
            },
        ],
        yearTurnover2: [{
            validator: (rule, value, callback) => {
                if (this.yearTurnover[1]) { callback(); return; }
                callback(new Error("请输入近年三年年度营业额"));
            },
            trigger: "blur",
        },],
        yearTurnover3: [{
            validator: (rule, value, callback) => {
                if (this.yearTurnover[2]) { callback(); return; }
                callback(new Error("请输入近年三年年度营业额"));
            },
            trigger: "blur",
        },],
        // 职工总数
        workforce: [
            { required: true, message: "请输入职工总数", trigger: "blur" },
            { type: "number", message: "必须为数字值", trigger: "blur" },
        ],
        // 高级职称
        seniorProf: [
            { required: true, message: "请输入高级职称", trigger: "blur" },
            { type: "number", message: "必须为数字值", trigger: "blur" },
        ],
        // 中级职称
        middleProf: [
            { required: true, message: "请输入中级职称", trigger: "blur" },
            { type: "number", message: "必须为数字值", trigger: "blur" },
        ],
        // 具有职业资格
        profQual: [
            { required: true, message: "请输入具有职业资格", trigger: "blur" },
            { type: "number", message: "必须为数字值", trigger: "blur" },
        ],
        // 研究生及以上
        postgraduateAbove: [
            { required: true, message: "请输入研究生及以上", trigger: "blur" },
            { type: "number", message: "必须为数字值", trigger: "blur" },
        ],
        // 规划资质等级
        planQualLevel: [{ required: true, message: "请选择规划资质等级", trigger: "change" }],
        // 资质证号
        qualCertNo: [{ required: true, message: "请输入资质证号", trigger: "blur" }],
        // 业务范围
        businessScope: [{ required: true, message: "请输入业务范围", trigger: "blur" }],



        // 单位法人
        unitLegalPerson: [
            { required: booleanTemp, message: "请输入单位法人", trigger: "blur" },
        ],
        // 联系电话
        contactNumber: [
            { required: booleanTemp, message: "请输入联系电话", trigger: "blur" },
        ],
        // 职务 / 职称
        jobTitle: [
            { required: booleanTemp, message: "请输入职务 / 职称", trigger: "blur" },
        ],
        // 单位代表
        unitRepresentative: [
            { required: booleanTemp, message: "请输入单位代表", trigger: "blur" },
        ],
        // 身份证号码
        idNumber: [
            { required: booleanTemp, message: "请输入身份证号码", trigger: "change" },
            { max: 18, min: 18, message: "身份证号码应该是18位的", trigger: "change" },
        ],
        // 政治面貌
        politicalOutlook: [
            { required: booleanTemp, message: "请输入政治面貌", trigger: "blur" },
        ],
        // 邮箱
        mailbox: [
            { required: booleanTemp, message: "请输入邮箱", trigger: "blur" },
        ],
        // 微信号
        wxCode: [{ required: booleanTemp, message: "请输入微信号", trigger: "blur" }],
        // qq号码
        qqCode: [{ required: booleanTemp, message: "请输入qq号码", trigger: "blur" }],

        // 申请注册承诺书
        promise: [{ required: booleanTemp, message: "请上传申请注册承诺书", trigger: "blur" }],
        // 营业执照复印件
        businessLicense: [{ required: booleanTemp, message: "请上传营业执照复印件", trigger: "change" }],
        // 单位资质证书复印件
        unitCert: [{ required: booleanTemp, message: "请上传单位资质证书复印件", trigger: "change" }],
        // 企业logo
        unitLogo: [{ required: booleanTemp, message: "请上传企业logo", trigger: "change" }],
        // 单位简介
        unitProfile: [{ required: booleanTemp, message: "请上传单位简介", trigger: "change" }],
    }
}

// 个人
export const PersonalFrom = {
    accountType: [{ required: true, message: "请选择账号类型", trigger: "change" }],
    memberType: [{ required: true, message: "请选择会员类型", trigger: "change" }],
    username: [
        { required: true, message: "请输入账号", trigger: "blur" },
        { validator: validateEng, trigger: "blur" },
    ],
    password: [
        { required: true, message: "请输入密码", trigger: "blur" },
        { min: 6, message: "密码需要在长度在6位以上", trigger: "blur" },
        { validator: validateEngPass, trigger: "blur" },
    ],

    fullName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
    gender: [{ required: true, message: "请选择性别", trigger: "blur" }],
    birthday: [
        {
            // type: "date",
            required: true,
            message: "请选择出生年月",
            trigger: "blur",
        },
    ],
    nativePlace: [
        { required: true, message: "请输入籍贯", trigger: "blur" },
    ],
    nation: [{ required: true, message: "请输入民族", trigger: "blur" }],
    politicalOutlook: [
        { required: true, message: "请选择政治面貌", trigger: "blur" },
    ],

    // 3
    // 
    education: [{ required: booleanTemp, message: "请选择学历", trigger: "blur" }],
    major: [{ required: booleanTemp, message: "请输入专业", trigger: "blur" }],
    workUnit: [
        { required: booleanTemp, message: "请输入工作单位", trigger: "blur" },
    ],
    jobTitle: [
        { required: booleanTemp, message: "请输入职务/职称", trigger: "blur" },
    ],
    address: [
        { required: booleanTemp, message: "请输入通讯地址", trigger: "blur" },
    ],
    telephone: [
        { required: booleanTemp, message: "请输入联系电话", trigger: "blur" },
    ],
    idNumber: [
        { required: booleanTemp, message: "请输入身份证号码", trigger: "change" },
        { max: 18, min: 18, message: "身份证号码应该是18位的", trigger: "change" },
    ],
    academicOrganization: [
        { required: booleanTemp, message: "请输入学术团体任何职位", trigger: "blur" },
    ],
    resume: [
        { required: booleanTemp, message: "请输入工作简历", trigger: "blur" },
    ],
    mainAcademic: [{ required: booleanTemp, message: "请输入主要学术", trigger: "blur" }],
    dateOfApplication: [
        {
            // type: "date",
            required: booleanTemp,
            message: "请选择申请日期",
            trigger: "blur",
        },
    ],



    application: [{ required: booleanTemp, message: "请上传", trigger: "change" }],
    profTitleCertificate: [{ required: booleanTemp, message: "请上传", trigger: "change" }],
    profQualCertificate: [{ required: booleanTemp, message: "请上传", trigger: "change" }],
}


export const validatorUrl = (rule, value, callback) => {
    if (!value) {
        callback();
    } else {
        let reg=/(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
        if (!reg.test(value)) {
            callback(new Error('您输入的不是网址！'));
        }
        callback();
    }
}